import { EPlacingType } from './placingType';
import { EServiceType } from './serviceType';

export interface IPublishOptions {
  /** Выбранный тип размещения */
  selectedPlacingType: EPlacingType;
  /** Периоды размещения */
  periods: IServicePeriods;
  /** Отсортированный список периодов размещения */
  periodIds: string[];
  /** Выбранный период размещения */
  selectedPeriodId: string | null;
  /** Пакеты размещения */
  packages: IServicePackages;
  /** Отсортированный список пакетов размещения */
  packageIds: string[];
  /** Выбранный пакет размещения */
  selectedPackageId: string | null;
  /** Рекомендованные пакеты, подписки */
  recommendedPackages: IRecommendedServicePackages;
  /** Отсортированный список рекомендованных пакетов */
  recommendedPackageIds: number[];
  /** Выбранный рекомендованный пакет */
  selectedRecommendedPackageId: number | null;
}

export interface IServicePeriods {
  [periodId: string]: IPublishOption;
}

export interface IServicePackages {
  [packageId: string]: IPublishOption;
}

export interface IRecommendedServicePackages {
  [packageId: number]: IRecommendedServicePackage;
}

export interface IPublishOption {
  /** Идентификатор опции размещения */
  id: string;
  /** Размер скидки, % */
  discount: number;
  /** Дата, до которой оплачено объявление */
  paidTill: string | null;
  /** Цена без скидки */
  marketingPrice: number;
  /** Цена со скидкой (если она есть) */
  price: number;
  /** Сколько осталось оплаченных дней для типов размещения на период */
  paidDaysLefts: number;
  /** Дата окончания публикации */
  endDate: string;
  /** Указывает на то, что объявление будет тарифицироваться в рамках купленного пакета по объему */
  isShouldPaidByServicePackageSlot: boolean;
  /** Остаток свободных слотов в купленном пакете по объему */
  servicePackageActualCount: number;
  /** Название периода */
  label: string;
  /** Оплачен */
  isPaid: boolean;
  /** На сколько дней рассчитан период */
  days: number;
  /** Список услуг */
  incompatibleServices: Array<EServiceType>;
  /** Является периодом по-умолчанию */
  isDefault: boolean;
  /** Дата окончания действия пакета = дата до которого будет опубликовано объявление за счет пакета */
  servicePackageEndDate: string;
  /** Объект тарифа */
  tariffIdentificator: ITariffIdentificator;
  /** Тип тарификации */
  type: EPublicationType;
  /** Дата окончания активности */
  activeTill: string | null;
  /** Код периода */
  key: string;
}

export interface ITariffIdentificator {
  /** Количество дней публикации */
  days: number;
  /** Id используемого пакета (тарифа в регионе) пользователя */
  packageId: number;
  /** Тип периода публикации */
  periodType: string;
  /** Список услуг */
  serviceTypes: string[];
  /** Тип тарифной сетки */
  tariffGridType: string;
  /** Id тарифной сетки */
  tariffId: number;
}

export enum EPublicationType {
  /** Ограниченная по дням публикация, подневная тарификация */
  dailyLimited = 'dailyLimited',
  /** Бессрочная публикация, подневная тарификация */
  dailyTermless = 'dailyTermless',
  /** Тарификация за весь период */
  periodical = 'periodical',
}

export interface IRecommendedServicePackage {
  /** Id услуги размещения пакета */
  serviceId: string;
  /** Скидка(в процентах) */
  discount: number;
  /** Цена за сутки */
  marketingPricePerDay: number;
  /** Цена пакета(после вычета дисконта) */
  totalPrice: number;
  /** Срок размещения объявления */
  serviceDurationInDays: number;
  /** Цена пакета */
  totalMarketingPrice: number;
  /** Актуальная цена за сутки(после вычета дисконта) */
  pricePerDay: number;
  /** Количество мест в пакете */
  count: number;
  /** Длительность пакета в днях */
  durationInDays: number;
  /** Названия регионов */
  regionNames: Array<string>;
  /** Id рекомендованного пакета */
  id: number;
  /** Типы размещения, которые содержит пакет */
  services: Array<EServiceType>;
  /** Ids полигонов на которые формируется рекомендованный пакет */
  polygonIds: Array<number>;
}
